import * as React from 'react'
import { SVGProps } from 'react'

const BNBUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_4956_76227)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 0C24.8372 0 32 7.16282 32 16C32 24.8372 24.8372 32 16 32C7.16282 32 0 24.8372 0 16C0 7.16282 7.16282 0 16 0Z'
        fill='white'
      />
      <path
        d='M8.7933 15.9999L8.80484 20.2306L12.3997 22.346V24.8229L6.70099 21.4806V14.7627L8.7933 15.9999ZM8.7933 11.7691V14.2345L6.69971 12.996V10.5306L8.7933 9.29218L10.8971 10.5306L8.7933 11.7691ZM13.901 10.5306L15.9946 9.29218L18.0984 10.5306L15.9946 11.7691L13.901 10.5306Z'
        fill='#F0B90B'
      />
      <path
        d='M10.3062 19.3537V16.8768L12.3997 18.1153V20.5806L10.3062 19.3537ZM13.901 23.2332L15.9946 24.4717L18.0985 23.2332V25.6986L15.9946 26.937L13.901 25.6986V23.2332ZM21.101 10.5306L23.1946 9.29218L25.2985 10.5306V12.996L23.1946 14.2345V11.7691L21.101 10.5306ZM23.1946 20.2306L23.2062 15.9999L25.2997 14.7614V21.4794L19.601 24.8217V22.3447L23.1946 20.2306Z'
        fill='#F0B90B'
      />
      <path d='M21.6931 19.3537L19.5996 20.5806V18.1153L21.6931 16.8769V19.3537Z' fill='#F0B90B' />
      <path
        d='M21.6933 12.6462L21.7049 15.1231L18.0997 17.2385V21.4795L16.0062 22.7065L13.9126 21.4795V17.2385L10.3074 15.1231V12.6462L12.41 11.4077L15.9933 13.5334L19.5985 11.4077L21.7023 12.6462H21.6933ZM10.3062 8.41671L15.9946 5.06287L21.6933 8.41671L19.5997 9.65517L15.9946 7.52953L12.3997 9.65517L10.3062 8.41671Z'
        fill='#F0B90B'
      />
    </g>
    <defs>
      <clipPath id='clip0_4956_76227'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default BNBUSD
